module.exports = __webpack_public_path__ + "img/succeed.8ac2e43d.png";